import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=882f47a8&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=882f47a8&prod&scoped=true&lang=scss"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=882f47a8&prod&lang=scss"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882f47a8",
  null
  
)

export default component.exports